import { FETCH_CLUSTER_NUMBER_IDP_REQUEST, FETCH_CLUSTER_NUMBER_IDP_SUCCESS, FETCH_CLUSTER_NUMBER_IDP_FAILURE } from "./ClusterNumberTypes";

const initialState = {
    loading: false,
    clusterNumberData: [],
    error: ''       
};

const clusterNumberReducer = (state = initialState, action) => {
    switch(action.type) {
        case FETCH_CLUSTER_NUMBER_IDP_REQUEST:  
            return {
                ...state,
                loading: true   
            };
        case FETCH_CLUSTER_NUMBER_IDP_SUCCESS:
            return {    
                loading: false,     
                clusterNumberData: action.payload,
                error: ''   
            };
        case FETCH_CLUSTER_NUMBER_IDP_FAILURE:
            return {    
                loading: false, 
                clusterNumberData: [],  
                error: action.payload
            };
        default:
            return state;
    }   
}

export default clusterNumberReducer;